import { IdType, SetStateAdapter } from '@industi/ngx-common';
import { Injectable } from '@angular/core';
import { Action, Selector } from '@ngrx/store';
import { getDiagramLastAddedId } from '../common.reducer';
import { DiagramClearLastAddedIdAction, DiagramSelectLastAddedIdAction } from '../actions/select-last-added-id.actions';

@Injectable({ providedIn: 'root' })
export class DiagramSetLastAddedAdapterService extends SetStateAdapter<IdType> {

  clearAction(): Action {
    return new DiagramClearLastAddedIdAction();
  }

  getValueSelector(): Selector<any, IdType> {
    return getDiagramLastAddedId;
  }

  setValueAction(value: IdType): Action {
    return new DiagramSelectLastAddedIdAction({ value });
  }

}
